export interface PackingOrderOutputProductItem {
  product_id: number;
  quantity: number;
  unit_id?: number | null;
}

// ── Especificación de insumos por grupo categoría+calidad+unidad ──────────────

export interface PackingOrderSpecifiedProduct {
  id: number;
  product_id: number;
  product_name: string;
  quantity: number;
  unit_id?: number | null;
  unit_name?: string | null;
  current_stock?: number;
}

export interface PackingOrderRequirementGroup {
  group_key: string;
  category_id?: number | null;
  category_name?: string | null;
  quality_id?: number | null;
  quality_name?: string | null;
  unit_id?: number | null;
  unit_name?: string | null;
  required_quantity_per_unit: number;
  required_quantity_total?: number;
  specified_total?: number;
  is_covered?: boolean;
  specified_products: PackingOrderSpecifiedProduct[];
}

export interface PackingOrderRequiredStockGroup {
  output_product_id: number;
  output_product_name: string;
  output_quantity: number;
  output_unit_name?: string | null;
  requirement_groups: PackingOrderRequirementGroup[];
}

export interface PackingOrderDataForm {
  id?: number;
  society_id?: number | null;
  society_name?: string;
  center_id?: number | null;
  warehouse_id?: number | null;
  program_date?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  status?: string;
  status_label?: string;
  is_periodic?: boolean;
  recurrence_days?: number[];
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  created_by_name?: string;
  updated_by_name?: string;
  /** Solo al crear: productos resultado con cantidad requerida */
  output_products?: PackingOrderOutputProductItem[];
}

export const defaultPackingOrderDataForm: PackingOrderDataForm = {
  society_id: undefined,
  program_date: '',
  start_date: '',
  end_date: '',
  status: 'CREATED',
  is_periodic: false,
  recurrence_days: [],
  is_active: true
};

export interface PackingOrderFilters {
  page: number;
  per_page: number;
  sort: string;
  order: string;
  id?: string;
  society_id?: string;
  status?: string;
  is_active?: string;
  start_date?: string;
  end_date?: string;
}

export interface PackingOrderOutputProductForm {
  id?: number;
  packing_order_id?: number;
  product_id?: number;
  product_code?: string;
  product_name?: string;
  quantity?: number;
  unit_id?: number | null;
  unit_name?: string;
  quantity_produced?: number;
}

export interface PackingOrderInputProductForm {
  id?: number;
  packing_order_id?: number;
  product_id?: number;
  product_name?: string;
  quantity?: number;
  unit_id?: number | null;
  unit_name?: string;
}

/** Lote disponible (FIFO) para un producto especificado en el modal Empacar */
export interface EmpacarBatchOption {
  batch_id: number;
  batch_name: string;
  center_name?: string | null;
  warehouse_name?: string | null;
  available_quantity: number;
  unit_name?: string | null;
}

/** Producto especificado por el usuario dentro de un grupo de requerimiento */
export interface EmpacarSpecifiedProduct {
  input_id: number;
  product_id: number;
  product_name: string;
  quantity_per_unit: number;
  unit_id?: number | null;
  unit_name?: string | null;
  batches: EmpacarBatchOption[];
}

/** Grupo de requerimiento (categoría+calidad+unidad) en empacar-data */
export interface EmpacarRequirementGroup {
  group_key: string;
  category_id?: number | null;
  category_name?: string | null;
  quality_id?: number | null;
  quality_name?: string | null;
  unit_id?: number | null;
  unit_name?: string | null;
  required_quantity_per_unit: number;
  specified_products: EmpacarSpecifiedProduct[];
}

/** Producto resultado en empacar-data */
export interface EmpacarOutputItem {
  output_product_id: number;
  output_product_name: string;
  output_quantity_required: number;
  output_unit_id?: number | null;
  output_unit_name?: string | null;
  requirement_groups: EmpacarRequirementGroup[];
}

export interface EmpacarDataResponse {
  packing_order_id: number;
  society_id?: number;
  center_id?: number;
  warehouse_id?: number;
  outputs: EmpacarOutputItem[];
}

/** Consumo por lote al ejecutar empacar */
export interface EmpacarConsumption {
  batch_id: number;
  quantity: number;
}

/** Payload por producto resultado al ejecutar empacar */
export interface EmpacarOutputPayload {
  output_product_id: number;
  quantity_elaborated: number;
  consumptions: EmpacarConsumption[];
}

export interface EmpacarExecutePayload {
  movement_date?: string;
  outputs: EmpacarOutputPayload[];
}

export interface EmpacarExecutePayload {
  movement_date?: string; // 'YYYY-MM-DD'
  outputs: EmpacarOutputPayload[];
}

/** Lote elaborado (sección Productos elaborados) */
export interface PackingOrderProducedBatchForm {
  id: number;
  packing_order_id: number;
  batch_id: number;
  batch_name: string;
  product_id: number;
  product_name: string;
  quantity_produced: number;
  unit_name?: string | null;
  created_at?: string | null;
}
